import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import FieldGroup from '../field_group/FieldGroup';
import Form from '../form/Form';
import { cfpFieldGroups } from '../field_group/CFPFields';
import {
  listBallastBrand,
  listBallastType,
} from '../../redux/references/ballast_actions';
import { getErrorValue } from '../../utils/utility';
import { requiredValidator } from '../field_group/validators';
export class BallastDetail extends React.Component {
  constructor(props) {
    super(props);
    this.formRef = undefined;
  }

  renderOption(item) {
    return (
      <option key={item.id} value={item.id}>
        {item.name}
      </option>
    );
  }

  getBallastData() {
    return this.formRef.getFormData();
  }

  componentDidMount() {
    this.props.listBrand();
    this.props.listType();
  }

  render() {
    const {
      name,
      brand_id,
      type_id,
      power_required,
      cfp_value,
      cfp_unit,
      description,
      image,
    } = this.props.ballast;
    const { ref, disabled, fieldErrors, t, ...otherAttr } = this.props;
    const customAttr = { disabled };
    return (
      <Form
        image={image}
        {...otherAttr}
        ref={ref => this.formRef = ref}
        errorMessage={getErrorValue(fieldErrors, 'detail')}
      >
        <FieldGroup
          id="lighting-ballast-name"
          field="name"
          type="text"
          label={t('name')}
          placeholder={t('name')}
          value={name}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'name')}
          {...customAttr}
        />
        <FieldGroup
          id="lighting-ballast-brand"
          field="brand_id"
          componentClass="select"
          label={t('brand')}
          placeholder="Ballast Brand"
          value={brand_id}
          defaultDirty={true}
          errorMessage={getErrorValue(fieldErrors, 'brand_id')}
          {...customAttr}
        >
          {this.props.brands.map(brand => this.renderOption(brand))}
        </FieldGroup>
        <FieldGroup
          id="lighting-ballast-type"
          field="type_id"
          componentClass="select"
          label={t('type')}
          placeholder="Ballast type"
          value={type_id}
          defaultDirty={true}
          errorMessage={getErrorValue(fieldErrors, 'type_id')}
          {...customAttr}
        >
          {this.props.types.map(type => this.renderOption(type))}
        </FieldGroup>
        <FieldGroup
          id="lighting-ballast-power-required"
          field="power_required"
          type="number"
          label={`${t('power (W)')}`}
          placeholder="60"
          value={power_required}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'power_required')}
          {...customAttr}
        />
        {cfpFieldGroups({ cfp_value, cfp_unit, disabled, fieldErrors, t })}
        <FieldGroup
          id="lighting-ballast-description"
          field="description"
          componentClass="textarea"
          label={t('description')}
          value={description}
          {...customAttr}
        />
      </Form>
    );
  }
}

BallastDetail.defaultProps = {
  ballast: {},
};

const mapStateToProps = state => ({
  brands: state.reference.ballast.brandList,
  types: state.reference.ballast.typeList,
});

const mapDispatchToProps = dispatch => ({
  listBrand: () => dispatch(listBallastBrand()),
  listType: () => dispatch(listBallastType()),
});

export default translate('translations', { withRef: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { withRef: true },
  )(BallastDetail),
);



// WEBPACK FOOTER //
// ./src/components/light/BallastDetail.js